export default __webpack_public_path__ + "static/media/house_map.007ac723.jpg";